var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolsStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74677 9.43835H23.0554C23.2837 9.43835 23.5027 9.52907 23.6642 9.69054C23.8257 9.85202 23.9164 10.071 23.9164 10.2994V22.7843H2.88574V10.2994C2.88574 10.071 2.97646 9.85202 3.13793 9.69054C3.29941 9.52907 3.51841 9.43835 3.74677 9.43835Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4441 10.9237H4.39262L4.37109 22.7973H22.4441V10.9237Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4812 12.7576H6.33405C6.02032 12.7576 5.76599 13.0197 5.76599 13.3431V20.3389C5.76599 20.6623 6.02032 20.9244 6.33405 20.9244H20.4812C20.7949 20.9244 21.0493 20.6623 21.0493 20.3389V13.3431C21.0493 13.0197 20.7949 12.7576 20.4812 12.7576Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68042 12.7576V20.9244",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93311 14.5098H7.5143",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93311 15.6765H7.5143",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93311 16.8431H7.5143",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93311 18.0099H7.5143",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93311 19.1765H7.5143",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84741 14.5098H11.5996",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0137 15.6765H15.6805",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0137 16.8431H12.7659",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84741 18.0099H12.7663",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0137 19.1765H14.8065",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46079 22.7972H25.3544C25.4685 22.7972 25.578 22.8426 25.6588 22.9233C25.7395 23.0041 25.7849 23.1136 25.7849 23.2278V24.2825H1.03027V23.2278C1.03027 23.1136 1.07563 23.0041 1.15637 22.9233C1.23711 22.8426 1.34661 22.7972 1.46079 22.7972Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7849 24.2826C23.4857 24.9382 21.1066 25.2715 18.7158 25.2728H8.09933C5.70851 25.2715 3.32945 24.9382 1.03027 24.2826H25.7849Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4387 14.8844C27.4736 14.8844 30.7445 11.6134 30.7445 7.57854C30.7445 3.54364 27.4736 0.272705 23.4387 0.272705C19.4037 0.272705 16.1328 3.54364 16.1328 7.57854C16.1328 11.6134 19.4037 14.8844 23.4387 14.8844Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9189 11.3843C21.7797 11.3845 21.6419 11.3573 21.5134 11.3041C21.3848 11.2509 21.268 11.1728 21.1698 11.0743L19.0473 8.95185C18.949 8.85347 18.8709 8.73669 18.8177 8.60816C18.7645 8.47963 18.7371 8.34187 18.7371 8.20275C18.7371 8.06363 18.7645 7.92587 18.8177 7.79734C18.8709 7.66881 18.949 7.55203 19.0473 7.45365C19.1457 7.35528 19.2625 7.27725 19.391 7.22401C19.5196 7.17077 19.6573 7.14337 19.7964 7.14337C19.9356 7.14337 20.0733 7.17077 20.2018 7.22401C20.3304 7.27725 20.4472 7.35528 20.5455 7.45365L21.9189 8.82269L26.224 4.51754C26.4233 4.31887 26.6933 4.20748 26.9746 4.20789C27.256 4.20829 27.5257 4.32045 27.7244 4.5197C27.923 4.71894 28.0344 4.98894 28.034 5.27031C28.0336 5.55168 27.9215 5.82137 27.7222 6.02004L22.668 11.0743C22.5697 11.1728 22.453 11.2509 22.3244 11.3041C22.1958 11.3573 22.058 11.3845 21.9189 11.3843V11.3843Z",
    fill: "#354153",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsStatus);
export default __webpack_public_path__ + "static/media/tools_status.b32b5dbcd87eacba4410c3d6cad99b6e.svg";
export { ForwardRef as ReactComponent };